import { render, staticRenderFns } from "./CharacteristicStep1.vue?vue&type=template&id=0908e9e2&"
import script from "./CharacteristicStep1.vue?vue&type=script&lang=js&"
export * from "./CharacteristicStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports